import { props } from 'ramda'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { TabsMenuItem } from '../../../../packages/kiti/components/tabs/TabsMenu'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import { useOpenEditScreenModal } from '../../../../utils/routes/modals/modalsActions'
import { useRemoveScreen } from '../_requests/removeScreen'
import { useScreens } from '../_load/ScreensLoader'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import IconText from '../../../../packages/kiti/components/presentation/IconText'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

import { useTranslation } from 'react-i18next'

const TabsMenu = () => {
  const { t } = useTranslation('dashboard')
  const tabs = useScreens()
  const openEditScreen = useOpenEditScreenModal()
  const [remove, { loading }] = useRemoveScreen()
  const { activeTabIndex, editing } = useForm()
  const { handleChange, removeIn } = useFormState()

  return (
    <Grid justify="flex-end" align="flex-end" gap={1.5}>
      {tabs?.map((option, index) => {
        const active = activeTabIndex === index

        return (
          <>
            <Col key={index}>
              <Grid align="center" gap={0.6}>
                <TabsMenuItem
                  active={active}
                  option={option}
                  onClick={() => handleChange('activeTabIndex', index)}
                  size="small"
                  {...props}
                />

                {editing && active && (
                  <>
                    <Col noMargin>
                      <Icon
                        name="BsFillPencilFill"
                        color="dark3"
                        size={0.7}
                        onClick={() => openEditScreen({ id: option.id, origin: 'dashboard' })}
                      />
                      <Separator weight={1} />
                    </Col>
                    <Col noMargin>
                      <Icon name="BsTrash" color="red" size={0.7} onClick={() => remove(option.id)} />
                      <Separator weight={1} />
                    </Col>
                  </>
                )}
              </Grid>
            </Col>
          </>
        )
      })}

      {editing && (
        <Col>
          <IconText
            icon="BsPlusCircle"
            color="primary"
            iconSize={0.8}
            label={t('newTab')}
            onClick={() => openEditScreen({ initialState: { screen: 'dashboard' } })}
          />
          <Separator weight={2} />
        </Col>
      )}
    </Grid>
  )
}

export default TabsMenu
